import React from "react";

import pageOne from "../images/Page-1.svg"
import pageTwo from "../images/Page-2.svg"
import downloadIcon from "../images/downloadIcon.svg"

export default class Resume extends React.Component {
    constructor () {
        super();
    }

    render() {
        return (
            <div className="resume-container">
                <div className="resume-content">
                    <img src={pageOne}></img>
                    <img src={pageTwo}></img>
                    <br></br>
                    <br></br>
                    <div className="download-button-container">
                        <a href="./files/Resume - Kent Pham.pdf" download id="download-link">
                            <div className="download-button">
                                <img src={downloadIcon} width="25px"></img>
                                <h4 className="download-button-text">Download Resume PDF</h4>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Resume.js